var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "renderer text-mono" }, [
    !!_vm.object.profilesCount
      ? _c("strong", { staticClass: "profiles" }, [
          _vm._v("\n    " + _vm._s(_vm.object.profilesCount) + "\n  "),
        ])
      : _c("span", { staticClass: "text-secondary" }, [_vm._v("0")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }